<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'system-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="employee-data" v-if="employee_data">
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('users.account')" class="mb-base">
            <div class="vx-row">
              <div class="vx-col" id="avatar-col">
                <div class="img-container mb-4">
                  <vs-avatar :src="avatar" size="80px" class="mr-4" />
                </div>
              </div>

              <div class="vx-col flex-1 my-auto" id="account-info-col-1">
                <table>
                  <tr>
                    <td class="font-semibold">{{ $t('users.username') }}</td>
                    <td>{{ employee_data.user.username }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">{{ $t('employees.status.status') }}</td>
                    <td>{{ $t('employees.status.' + employee_data.status) }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="vx-col w-full flex" id="account-manage-buttons">
              <vs-button
                icon-pack="feather"
                icon="icon-edit"
                class="mr-4"
                :to="{ name: 'business-employee-edit', params: { Id: $route.params.id } }"
                >{{ $t('button.edit') }}</vs-button
              >
            </div>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('users.information')" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('users.first_name') }}</td>
                <td>{{ employee_data.user.details.firstName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.last_name') }}</td>
                <td>{{ employee_data.user.details.lastName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.birthday') }}</td>
                <td>{{ employee_data.user.details.birthday | datetime }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('users.genders.gender') }}</td>
                <td>{{ $t(`users.genders.${employee_data.user.details.gender}`) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('employees.phones') }}</td>
                <td v-if="employee_data.phones">{{ employee_data.phones.join(', ') }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="اطلاعات مالی" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('documents.bank_name') }}</td>
                <td>{{ employee_data.bankName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('documents.branch_no') }}</td>
                <td>{{ employee_data.branchNo }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('documents.iban') }}</td>
                <td>{{ employee_data.IBAN }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('documents.credit_card') }}</td>
                <td>{{ employee_data.creditCard }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <!-- <connection-info :employee_data="employee_data"></connection-info> -->
          <vx-card :title="$t('documents.docs_and_grades')" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('documents.grade') }}</td>
                <td>{{ employee_data.grade }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('documents.field_of_study') }}</td>
                <td>{{ employee_data.fieldOfStudy }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('documents.license_no') }}</td>
                <td v-if="employee_data.docs">{{ employee_data.docs.join(', ') }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('documents.attachments') }}</td>
                <td v-if="employee_data.docs">{{ employee_data.docs.join(', ') }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moduleEmployee from '@/store/employee/moduleEmployee.js'

export default {
  data() {
    return {
      employee_data: null,
      avatar: null,
      user_not_found: false,
      employee_not_found: false
    }
  },
  created() {
    this.$vs.loading()
    if (!moduleEmployee.isRegistered) {
      this.$store.registerModule('employee', moduleEmployee)
      moduleEmployee.isRegistered = true
    }
    const employeeId = this.$route.params.id
    this.$store
      .dispatch('employee/fetchEmployee', employeeId)
      .then(res => {
        this.employee_data = res.data.employee
        //get avatar
        if (this.employee_data.user.avatar) {
          this.$store.dispatch('file/downloadFile', this.employee_data.user.avatar).then(response => {
            this.avatar = response
          })
        }
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true
        }
      })
      .finally(() => this.$vs.loading.close())
  }
}
</script>

<style lang="scss">
#employee-data {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }
  }
}
</style>
